// Percentages use integer units of 0.0001%, matching the API.
export function rebalanceRewards (rewards, createIfMissing = true) {
  const rows = rewards.map(row => ({ ...row }))
  if (rows.some(row => Number(row.type) !== 1 && (!Number.isFinite(Number(row.winning_percentage)) || Number(row.winning_percentage) < 0.0001))) {
    throw new Error('spinningWheel.percentageRequired')
  }
  const total = rows.filter(row => Number(row.type) !== 1 && row.active)
    .reduce((sum, row) => sum + Math.round(Number(row.winning_percentage) * 10000), 0)
  if (total > 1000000) throw new Error('spinningWheel.percentageOverflow')
  let nothing = rows.find(row => Number(row.type) === 1)
  const result = rows.filter(row => Number(row.type) !== 1)
  if (!nothing && createIfMissing && result.length) {
    nothing = { id: 'nothing', type: 1, display_title: '', display_description: '', sort_order: 9999 }
  }
  if (nothing) {
    nothing.winning_percentage = (1000000 - total) / 10000
    nothing.active = total < 1000000
    result.push(nothing)
  }
  result.forEach(row => { row._savedWinningPercentage = row.winning_percentage })
  return result.sort((a, b) => a.sort_order - b.sort_order)
}

export function rewardTitle (row, nothingLabel) {
  const title = row.display_title || row.name
  return Number(row.type) === 1 && (!title || title === 'Nothing') ? nothingLabel : title
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/Views/Marketing/SpinningWheel/rewards.js